import * as effects from 'redux-saga/effects';

import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';

import { ExportTypes } from './Types';
import { 
    getExportError, 
    getExportSuccess, 
    getExportDashboardPdf, 
    getExportDashboardXls, 
    getExportPlayerPdf, 
    getExportPlayerXls, 
    getExportStatsEvolutionPdf, 
    getExportStatsEvolutionXls, 
    getExportDashboardDetailsPdf, 
    getExportDashboardDetailsXls 
} from './Actions';
import { IApplicationState } from '..';


function* handleExportDashboardPdf(action: ReturnType<typeof getExportDashboardPdf>) {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.generatePdfFile, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportDashboardPdf');
        yield effects.put(getExportError());
    }
}

function* handleExportDashboardXls(action: ReturnType<typeof getExportDashboardXls>) {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.generateExcelFile, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportDashboardXls');
        yield effects.put(getExportError());
    }
}

function* handleExportPlayerPdf(action: ReturnType<typeof getExportPlayerPdf>) {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.getPdfPlayerRapidSearch, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportPlayerPdf');
        yield effects.put(getExportError());
    }
}

function* handleExportPlayerXls(action: ReturnType<typeof getExportPlayerXls>) {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.getXlsPlayerRapidSearch, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportPlayerXls');
        yield effects.put(getExportError());
    }
}

function* handleExportStatsEvolutionPdf(action: ReturnType<typeof getExportStatsEvolutionPdf>) {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.getStatsEvolutionPdf, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportStatsEvolutionPdf');
        yield effects.put(getExportError());
    }
}

function* handleExportStatsEvolutionXls(action: ReturnType<typeof getExportStatsEvolutionXls>) {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.getStatsEvolutionXls, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportStatsEvolutionXls');
        yield effects.put(getExportError());
    }
}

function* handleExportDashboardDetailsPdf(action: ReturnType<typeof getExportDashboardDetailsPdf>) {
    const backend = Backend.getInstance();
    try {
        const isElectionsLegislative: boolean = yield effects.select((state: IApplicationState) => state.elections.isElectionsLegislative);
        const res = isElectionsLegislative 
            ? yield effects.apply(backend, backend.generatePdfDashboardLegislativeDetails, [action.payload])
            : yield effects.apply(backend, backend.generatePdfDashboardDetails, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportDashboardDetailsPdf');
        yield effects.put(getExportError());
    }
}

function* handleExportDashboardDetailsXls(action: ReturnType<typeof getExportDashboardDetailsXls>) {
    const backend = Backend.getInstance();
    try {
        const isElectionsLegislative: boolean = yield effects.select((state: IApplicationState) => state.elections.isElectionsLegislative);
        const res = isElectionsLegislative 
            ? yield effects.apply(backend, backend.generateXlsDashboarLegislativedDetails, [action.payload])
            : yield effects.apply(backend, backend.generateXlsDashboardDetails, [action.payload]);
        yield effects.put(getExportSuccess(res));
    } catch (err) {
        Logger.warn({ err }, 'Failed getExportDashboardDetailsXls');
        yield effects.put(getExportError());
    }
}

function* watchExport() {
    yield effects.takeEvery(ExportTypes.GET_EXPORT_DASHBOARD_PDF, handleExportDashboardPdf);
    yield effects.takeEvery(ExportTypes.GET_EXPORT_DASHBOARD_XLS, handleExportDashboardXls);
    yield effects.takeEvery(ExportTypes.GET_EXPORT_PLAYER_PDF, handleExportPlayerPdf);
    yield effects.takeEvery(ExportTypes.GET_EXPORT_PLAYER_XLS, handleExportPlayerXls);
    yield effects.takeEvery(ExportTypes.GET_EXPORT_STATS_EVOLUTION_PDF, handleExportStatsEvolutionPdf);
    yield effects.takeEvery(ExportTypes.GET_EXPORT_STATS_EVOLUTION_XLS, handleExportStatsEvolutionXls);
    yield effects.takeEvery(ExportTypes.GET_EXPORT_DASHBOARD_DETAILS_PDF, handleExportDashboardDetailsPdf);
    yield effects.takeEvery(ExportTypes.GET_EXPORT_DASHBOARD_DETAILS_XLS, handleExportDashboardDetailsXls);
}

export function* ExportSaga() {
    yield effects.all([
        effects.fork(watchExport),
    ]);
}
